module.exports = __webpack_public_path__ + "87448c5ba6b15616439bd55702079feb.svg";